import { render } from "./ProscanFileViewer.vue?vue&type=template&id=0bf4ebf4&scoped=true"
import script from "./ProscanFileViewer.vue?vue&type=script&lang=js"
export * from "./ProscanFileViewer.vue?vue&type=script&lang=js"

import "./ProscanFileViewer.vue?vue&type=style&index=0&id=0bf4ebf4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bf4ebf4"]])

export default __exports__